import styled from 'styled-components';

export const NewsLetterStyled = styled.div`
  width: 100%;
  background-color: #f7fbfe;
  margin-top: 40px;
`;

export const ContainerStyled = styled.div`
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 30px;
  padding: 30px 18px;

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: 30px 74px;

    max-width: 1300px;
  }
  @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    flex-direction: row;
    gap: 105px;
    align-items: center;
  }

  .main-text {
    display: flex;
    gap: 14px;
    flex-direction: column;

    & .get-update {
      font-size: 16px;
      line-height: 19.36px;
    }

    @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
      flex: 40%;
    }
  }
  & .join {
    font-size: 20px;
    line-height: 24.2px;
    @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
      font-size: 24px;
      line-height: 29.05px;
    }
    @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
      font-size: 32px;
      line-height: 38.73px;
    }
  }

  .subscribe {
    display: flex;
    flex-direction: column;
    gap: 14px;
    @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
      margin-top: 60px;
      flex: 60%;
    }

    & .subscribe-input {
      display: flex;
      align-items: center;
      gap: 17px;

      & .input {
        border-radius: 5px;
        border: 1px solid ${({ theme }) => theme.colors.disable};
        width: 100%;

        ::placeholder {
          color: #949494;
          font-size: 14px;
          line-height: 16.94px;
        }
      }
    }
  }
`;
